// extracted by mini-css-extract-plugin
export var box = "Input-module--box--hw5jZ";
export var input = "Input-module--input--fCg9f";
export var label = "Input-module--label--Ky8sz";
export var error = "Input-module--error--uaGmr";
export var full_width = "Input-module--full_width--gHXS6";